//
// Shop: Countdown
//

( function($, waTheme) {

    var CountDown = (function ($) {

        CountDown = function (options) {
            var that = this;

            // DOM
            that.$wrapper = create(options["$wrapper"]);
            that.$day = that.$wrapper.find(".js-day");
            that.$hour = that.$wrapper.find(".js-hour");
            that.$minute = that.$wrapper.find(".js-minute");
            that.$second = that.$wrapper.find(".js-second");

            // VARS
            that.locale = (options["locale"] || "en");
            that.start = options["start"];
            that.end = options["end"];
            that.short = options["short"];

            // DYNAMIC VARS
            that.period = that.getPeriod();
            that.time_period = null;
            that.timer = 0;

            // INIT
            that.run();

            that.$wrapper.data("countdown", that);
        };

        CountDown.prototype.getPeriod = function () {
            var that = this,
                start_date = new Date(that.start),
                end_date = new Date(that.end);

            return (end_date > start_date) ? (end_date - start_date) : 0;
        };

        CountDown.prototype.getData = function () {
            var that = this,
                period = that.period;

            var second = 1000,
                minute = second * 60,
                hour = minute * 60,
                day = hour * 24,
                residue;

            var days = Math.floor(period / day);
            residue = (period - days * day);

            var hours = Math.floor(residue / hour);
            residue = (residue - hours * hour);

            var minutes = Math.floor(residue / minute);
            residue = (residue - minutes * minute);

            var seconds = Math.floor(residue / second);

            return {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            }
        };

        CountDown.prototype.render = function (data) {
            var that = this,
                delta = 0;

            if (that.short) {
                var locales = {
                    en: {
                        day: ["d", "d", "d"],
                        hour: ["h", "h", "h"],
                        minute: ["m", "m", "m"],
                        second: ["s", "s", "s"]
                    },
                    ru: {
                        day: ["д", "д", "д"],
                        hour: ["ч", "ч", "ч"],
                        minute: ["м", "м", "м"],
                        second: ["с", "с", "с"]
                    }
                };
            } else {
                var locales = {
                    en: {
                        day: ["day", "days", "days"],
                        hour: ["hour", "hours", "hours"],
                        minute: ["minute", "minutes", "minutes"],
                        second: ["second", "seconds", "seconds"]
                    },
                    ru: {
                        day: ["день", "дня", "дней"],
                        hour: ["час", "часа", "часов"],
                        minute: ["минута", "минуты", "минут"],
                        second: ["секунда", "секунды", "секунд"]
                    }
                };
            }

            var locale = (that.locale in locales ? locales[that.locale] : locales["en"]);

            // Day
            var day = data.days,
                day_label;

            if (day === 1) {
                day_label = locale.day[0];
            } else if (day > 1 && day < 5) {
                day_label = locale.day[1];
            } else {
                day_label = locale.day[2];
            }

            that.$day.find(".s-count").text(day);
            that.$day.find(".s-label").text(day_label);

            // Hour
            var hour = data.hours,
                hour_label;

            if ((hour === 1) || hour === 21) {
                hour_label = locale.hour[0];
            } else if ((hour > 1 && hour < 5) || hour > 20) {
                hour_label = locale.hour[1];
            } else {
                hour_label = locale.hour[2];
            }

            if (hour < 10) {
                hour = "0" + hour;
            }

            that.$hour.find(".s-count").text(hour);
            that.$hour.find(".s-label").text(hour_label);

            // Minute
            var minute = data.minutes,
                minute_label;

            if (minute === 1) {
                minute_label = locale.minute[0];
            } else if (minute > 1 && minute < 5) {
                minute_label = locale.minute[1];
            } else {
                minute_label = locale.minute[2];
            }

            if (minute > 20) {
                delta = minute % 10;
                if (delta === 1) {
                    minute_label = locale.minute[0];
                } else if (delta > 1 && delta < 5) {
                    minute_label = locale.minute[1];
                } else {
                    minute_label = locale.minute[2];
                }
            }

            if (minute < 10) {
                minute = "0" + minute;
            }

            that.$minute.find(".s-count").text(minute);
            that.$minute.find(".s-label").text(minute_label);

            // Second
            var second = data.seconds,
                second_label;

            if (second === 1) {
                second_label = locale.second[0];
            } else if (second > 1 && second < 5) {
                second_label = locale.second[1];
            } else {
                second_label = locale.second[2];
            }

            if (second > 20) {
                delta = second % 10;

                if (delta === 1) {
                    second_label = locale.second[0];
                } else if (delta > 1 && delta < 5) {
                    second_label = locale.second[1];
                } else {
                    second_label = locale.second[2];
                }
            }

            if (second < 10) {
                second = "0" + second;
            }

            that.$second.find(".s-count").text(second);
            that.$second.find(".s-label").text(second_label);
        };

        CountDown.prototype.run = function () {
            var that = this,
                timer = 1000;

            if (that.period > 0) {

                var data = that.getData();

                that.render(data);

                that.period -= timer;

                if (that.period > 0) {
                    that.timer = setTimeout(function () {
                        that.run();
                    }, timer);
                }

            } else {
                that.destroy();
            }
        };

        CountDown.prototype.destroy = function () {
            var that = this;

            that.$wrapper.remove();
        };

        return CountDown;

        function create($wrapper) {
            var html = "<span class=\"s-count-item js-day\"><span class=\"s-count\"></span><span class=\"s-label\"></span></span>" +
                "<span class=\"s-count-item js-hour\"><span class=\"s-count\"></span><span class=\"s-label\"></span></span>" +
                "<span class=\"s-count-item js-minute\"><span class=\"s-count\"></span><span class=\"s-label\"></span></span>" +
                "<span class=\"s-count-item js-second last\"><span class=\"s-count\"></span><span class=\"s-label\"></span></span>";

            $wrapper.html(html);

            return $wrapper;
        }

    })($);

    waTheme.init.shop.CountDown = CountDown;

    var $countdowns = $(".js-countdown");
    if ($countdowns.length) {
        $countdowns.each( function() {
            var $wrapper = $(this),
                options = {
                    $wrapper: $wrapper,
                    locale: window.waTheme.config.locale,
                    start: $wrapper.data('start').replace(/-/g, '/'),
                    end: $wrapper.data('end').replace(/-/g, '/'),
                    short: $wrapper.data('short'),
                };

            if (!$wrapper.data("countdown")) {
                new waTheme.init.shop.CountDown(options);
            }
        });
    }

})(jQuery, window.waTheme);
